import React, { Component } from 'react';
import settings from './../../../settings';
import aidao from './../../../assets/images/Aidao.svg';

export default class DAOLevel extends Component {

  render() {
    const data = this.props.data;

    var daobalance = parseFloat(window.daobalance);
    var max, level;

    for (var i = 1; i < 11; i++){
        var current_level = settings.daolevel[i.toString()]
        if (current_level > daobalance) {
            max = current_level;
            level = data.level + i.toString()
            break;
        } else if (i === 10){
            max = daobalance;
            level = data.level + i.toString()
        }
    }

    var bar_style = {
        width: parseInt(daobalance / max * 100).toString() +"%",
    }

    return (
        <div class="widget-detail-2 text-right">

            <h3 class="non-blocking pull-left">{level}</h3><h3 class="non-blocking"><img src={aidao} class="token32" alt="aidao logo"/> <span id="daobalance">{daobalance}</span> DAO </h3>

            <p class="text-muted m-t-5">({daobalance}/{max})</p>
            <div class="progress progress-bar-success-alt progress-md m-t-5 m-b-0">
                <div class="progress-bar progress-animated" id="dao-progress-bar" role="progressbar"
                            aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style={bar_style}>
                </div>
            </div>

        </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/functions/daolevel.js